import React from "react";

import Button from "../Button";

// Icons imports
import { FaArrowAltCircleRight } from "react-icons/fa";

// Scss imports
import css from "./CategoriesProcessorsNavigation.module.scss";

import { useHistory } from "react-router-dom";

interface CategoriesProcessorsNavigationProps {
  text?: string;
  processorButtonClickHandler: any;
  showAllText: string;
}

const CategoriesProcessorsNavigation: React.FC<CategoriesProcessorsNavigationProps> =
  ({ processorButtonClickHandler, showAllText }) => {
    const history = useHistory();

    return (
      <div className={css.container}>
        <div className={css.buttonsContainer}>
          <div className={css.buttonWrapper}></div>
          <Button
            text={showAllText}
            onButtonClickHandler={processorButtonClickHandler}
            type="processorsButton"
          />
        </div>

        <div onClick={() => history.push("/")} className={css.exitContainer}>
          <p>Изађи</p>
          <FaArrowAltCircleRight className={css.circleIcon} />
        </div>
      </div>
    );
  };

export default CategoriesProcessorsNavigation;
